import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";

import Account from "./Account";
import Contact from "./Contact";

export default function(moduleId) {
  switch (moduleId) {
    case STANDARD_MODULE_IDS.accounts.id:
      return Account;
    default:
      return Contact;
  }
}
